import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';
import { CdnImg } from '@webplatform/cdn-image';
import { useBreakpoint } from '~/composables';

interface Props {
  data?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CtaSectionBanner',
  props: {
    data: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { data: any };



const { isBiggerThanBreakpoint: mdAndUp } = useBreakpoint('md');
const banner = computed(() => {
  let image = props.data.banner.src;

  if (!image) return undefined;

  if (!mdAndUp.value) {
    image =
      props.data.banner.mobile && props.data.banner.mobile.src
        ? props.data.banner.mobile.src
        : props.data.banner.src;
  }
  return image;
});
const bannerSizes = computed(() => {
  if (mdAndUp.value)
    return {
      width: 1824,
      height: 240,
    };
  return {
    width: 654,
    height: 560,
  };
});

return { __sfc: true,props, mdAndUp, banner, bannerSizes, CdnImg }
}

})